import { useContext, useEffect, useState } from "react";
import { EDirectoryPreferences } from "../interface/INDDPreference";
import { getServiceApiRoute } from "@api-routes";
import { MERGE_PATCH_HEADER } from "@constants";
import {
    getResponseToState,
    getStateToPayload,
    IDirectoryPreferencesResponse,
} from "../mappers/getNDDPreferencesMapper";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { useFetch } from "@common/hook/useFetch";

export const useNDDPreferences = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [selectedPreference, setSelectedPreference] = useState<EDirectoryPreferences>();
    const [isLoading, setIsLoading] = useState(false);
    const [getNDDPreferenceState, { get }] = useFetch();
    const [updateNDDPreferenceState, { patch }] = useFetch();

    const getNDDPreferences = () => {
        if (selectedService) {
            setIsLoading(true);
            get<IDirectoryPreferencesResponse>(getServiceApiRoute(selectedService.id), {
                forwardError: true,
            })
                .then((directoryPreferencesResponse) => {
                    setIsLoading(false);
                    if (directoryPreferencesResponse) {
                        setSelectedPreference(getResponseToState(directoryPreferencesResponse));
                    }
                })
                .catch(() => setIsLoading(false));
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getNDDPreferences, [selectedService]);

    const updateNDDPreference = (nationalDirectoryName: EDirectoryPreferences): void => {
        if (selectedService) {
            setIsLoading(true);
            patch<boolean>(getServiceApiRoute(selectedService.id), {
                body: getStateToPayload(nationalDirectoryName),
                headers: MERGE_PATCH_HEADER,
            }).then(getNDDPreferences);
        }
    };

    return {
        getNDDPreferenceState,
        getNDDPreferences,
        isLoading,
        selectedPreference,
        updateNDDPreference,
        updateNDDPreferenceState,
    };
};
